﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import { RouteLink } from "~base/Components/Primitives/Link";
import type { StartPageCustomizations } from "~base/Pages/Home/Start";
import type { IntlContext } from "~base/Internationalization/IntlContext";
import type * as sessionModel from "~base/Services/API/Session/Model";

export default {
    individualIdentifierFormat: "Full",
    organizationIdentifierFormat: "Short",
    identifierTextCode: "VisiFinance.UI.Start.KundensPersonnummer",
    adminMenu: (role: string) =>
        role == "advisor" || role == "tenantadmin" || role == "sysadmin" ? (
            <RouteLink
                testIdentifier="Administration"
                forceLoadAsExternal={true}
                to={"/Admin"}
            >
                Administration
            </RouteLink>
        ) : (
            []
        ),
    additionalAllowedOrganizationTypes: [],
    tryForPreferredUiCulture: true,
    formatSessionDisplayName: (
        intl: IntlContext,
        session: sessionModel.Session,
        sessionModelInfo: sessionModel.GetStartInfoSessionModel
    ) => {
        const sessionModelName = intl.tryFormatText(session.sessionModelFqn);
        const creationDate = intl.formatDateMonthTimeLong(session.creationDate);
        const displayValue = !!sessionModelName
            ? `${sessionModelName} - ${creationDate}`
            : creationDate;

        if (session.access == "Read") {
            return displayValue + " *";
        }
        return displayValue;
    },
} as StartPageCustomizations;
